/* eslint-disable react/destructuring-assignment */
import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import type { SkeletonProps } from '@chakra-ui/react';

const breadcrumbsLoadedStyles = {
    padding: {
        base: '1rem',
        sm: '1rem 2rem',
        md: '1rem 2rem',
        lg: '1rem 2.5rem',
        xl: '1rem 4rem',
    },
};

const breadcrumbsUnloadedStyles = {
    height: '22px',
    marginX: { base: 4, sm: 8, md: 8 },
    marginY: 4,
    width: { base: '167px', sm: '183px' },
};

export const GDPBreadcrumbsSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        {...(props.isLoaded ? breadcrumbsLoadedStyles : breadcrumbsUnloadedStyles)}
        lineHeight="short"
        data-testid="gdp-giftcard-breadcrumbs-skeleton"
    />
);

export const GDPBuyBoxSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={
            props.isLoaded ? undefined : { base: '1128px', sm: '956px', md: '1128px', lg: '1104px' }
        }
        width="100%"
        data-testid="gdp-giftcard-buy-box-skeleton"
    />
);

export const GDPPhotoGridSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : { md: '576px', lg: '738px', xl: '1003px' }}
        marginX={{ base: 4, sm: 8, md: 0 }}
        data-testid="gdp-giftcard-photo-grid-skeleton"
    />
);

export const GDPWhatCanYouGetSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={
            props.isLoaded ? undefined : { base: '1146px', sm: '1314px', md: '592px', xl: '606px' }
        }
        width="100%"
        data-testid="gdp-giftcard-what-can-you-get-skeleton"
    />
);

export const GDPDiscoverCookingClassSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : { base: '660px', sm: '690px', md: '654px' }}
        width="100%"
        data-testid="gdp-giftcard-discover-cooking-class-skeleton"
    />
);

export const GDPFAQSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : { base: '765px', sm: '573px', md: '489px' }}
        width="100%"
        data-testid="gdp-giftcard-faq-skeleton"
    />
);
